import React, { useContext, useState } from 'react'
import type { IEvent } from '../../api/dto/IEvent'
import CustomImage from '../customImage/customImage'
import { Timer } from '../timer/timer'
import { formatDate } from '../../assets/constants/date'
import { InitialStateContext } from '../../App'
import { isLiveMatch } from '../../assets/constants/isLiveMatch'
import { LoadMoreIcon } from '../../assets/icons/loadMoreIcon'
import { EventPreviewBackground } from '../../assets/icons/eventPreviewBackground'
import { ASSETS_URL } from '../../assets/constants/assetsUrl'

interface IProps {
    item?: IEvent
    onClick: () => void
}

const TeamBlock = ({
    teamLogo,
    teamName,
}: {
    teamLogo: string
    teamName: string
}) => (
    <div className="flex flex-col items-center justify-center lg:w-[128px] lg:h-[128px] sm:w-[100px] sm:h-[100px] w-[80px] h-[80px] text-white bg-darkBlueOpacity0 rounded-[100%]">
        <CustomImage
            width={85}
            height={85}
            className="lg:w-[85px]  lg:h-[85px] sm:w-[72px] sm:h-[72px] w-[50px] h-[50px]"
            mockImg="/images/mockLogos/noTeam.svg"
            src={teamLogo}
            alt={teamName}
        />
    </div>
)

export const EventHeader = ({ item, onClick }: IProps) => {
    const { differanceTimeZoneInMs } = useContext(InitialStateContext)
    const [isLiveState, setIsLiveState] = useState(false)
    const startTimeFunk = (format: string) =>
        formatDate(
            new Date((item?.start_time || 0) * 1000 + differanceTimeZoneInMs),
            format
        )
    const gtmTime = Math.floor(new Date().getTime() / 1000)
    const isMatchEnd = item?.end_time && gtmTime >= item.end_time
    return (
        <div
            style={{
                backgroundPosition: 'center center',
                background: `linear-gradient( rgba(10, 23, 30, 0.9) 100%, rgba(10, 23, 30, 0.9) 100%),url("${ASSETS_URL}${item?.bg_image}")`,
            }}
            className="h-full rounded-lg flex flex-col items-center justify-center w-full"
        >
            <div className="relative lg:w-[562px] lg:h-[193px] sm:w-[490px] sm:h-[169px] w-[343px] h-[118px]">
                <div className="absolute top-0 ml-auto mr-auto right-0 left-0 z-0">
                    <EventPreviewBackground className="" />
                </div>
                <div className="absolute top-[-8px] ml-auto mr-auto right-0 left-0  w-fit">
                    <span className="font-poppinsBold text-white  sm:text-[16px] text-[12px] py-1">
                        {startTimeFunk('HH:mm')}
                    </span>
                </div>
                <div className="z-10 flex items-center justify-center rounded-[18px] sm:gap-12  gap-6 relative h-full">
                    <TeamBlock
                        teamLogo={item?.participantHome.logo || ''}
                        teamName={item?.participantHome.name || ''}
                    />
                    {isLiveState || isLiveMatch(item) ? (
                        <div
                            onClick={onClick}
                            className="cursor-pointer flex items-center justify-center bg-white w-[130px] h-[32px] sm:h-[42px] rounded-lg"
                        >
                            <span
                                className={`whitespace-nowrap text-[16px] sm:text-[20px] text-green font-rubikBold mr-2`}
                            >
                                Refresh
                            </span>
                            <LoadMoreIcon className="stroke-green w-[20px] h-[20px]" />
                        </div>
                    ) : isMatchEnd ? (
                        <span className="whitespace-nowrap text-[16px] sm:text-[20px] text-green font-rubikBold mr-2 bg-white w-[130px] h-[32px] sm:h-[42px] flex items-center justify-center rounded-lg">
                            Finish
                        </span>
                    ) : (
                        <span
                            className={`flex flex-col justify-center items-center whitespace-nowrap h-full gap-1 lg:gap-3`}
                        >
                            <span className="font-poppinsRegular text-whiteOpacity4 hidden unique:block text-base">
                                Remaining time
                            </span>
                            <span className="font-poppinsBold text-white sm:text-[40px] sm:w-[175px] text-[25px] w-[125px] text-center">
                                <Timer
                                    endTime={(item?.start_time || 0) * 1000}
                                    onClick={onClick}
                                    onEnd={() => {
                                        onClick()
                                        setIsLiveState(true)
                                    }}
                                />
                            </span>
                            <span className="text-white ">
                                {startTimeFunk('dd MMMM')}
                            </span>
                        </span>
                    )}
                    <TeamBlock
                        teamLogo={item?.participantAway.logo || ''}
                        teamName={item?.participantAway.name || ''}
                    />
                </div>
            </div>
        </div>
    )
}
